// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"86c59c13","455":"b19e4417"}[chunkId] + ".chunk.js";
};